module.exports = __webpack_public_path__ + "img/WXbarcode.f4dad14f.png";